import React, { useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { useAuth } from "../../Store/AuthContext";
import axios from "axios";
import ProjectBox from "../../Component/ProjectCMPT/ProjectBox";
// import APIDataFetchLoader from "../../Utils/APIDataFetchLoader";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function Projects() {
  const { projectcatslug } = useParams();
  // const navigate = useNavigate();
  const { RendomTokenfetch } = useAuth();
  const [projectData, setprojectData] = useState([]);
  // const [Showproject, setShowproject] = useState(true);
  // console.log(projectData);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [TotalBlogs, setTotalBlogs] = useState(1);

  const limit = 6; // per page blogs

  const FetchProjectData = useCallback(async () => {
    setLoading(true);
    try {
      await axios
        .get(
          `${WebsiteAPIurl}projectsAPI.php?catslug=${projectcatslug}&page=${currentPage}&limit=${limit}`,
          {
            headers: {
              Authorization: RendomTokenfetch,
            },
          }
        )
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setprojectData(response.data.projectdata);
            setTotalPages(response.data.totalPages);
            setTotalBlogs(response.data.totalBlogs);
            // setShowproject(true);
          } else {
            setprojectData([]);
            // setShowproject(false);
          }
        });
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, projectcatslug, currentPage]);

  useEffect(() => {
    FetchProjectData();
  }, [FetchProjectData]);

  if (loading) {
    // return <APIDataFetchLoader />;
  }

  // 🟢 Pagination Buttons
  const renderPagination = () => {
    let pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => setCurrentPage(i)}
          className={`px-3 py-1 mx-1 rounded-lg border 
            ${
              currentPage === i
                ? "bg-red-600 text-white border-red-600"
                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
            }`}
        >
          {i}
        </button>
      );
    }
    return pages;
  };

  return (
    <>
      <Helmet>
        <title>{projectcatslug} - Bhadorva Infra</title>
        <meta
          name="description"
          content="At Bhadorva Infra, we bring over 15 years of expertise in real estate, specializing in luxury bungalows, premium plotting, and high-quality construction. Our commitment lies in shaping developments that reflect elegance, comfort, and timeless luxury, setting new benchmarks in modern living."
        />
        <meta
          name="keywords"
          content="Bhadorva Infra,real estate,specializing in luxury bungalows, premium plotting, high-quality construction"
        />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename={projectcatslug} mainpage="" />

      <section className="project-section fix section-padding pt-3 section-bg">
        <div className="container">
          <div className="row">
            {loading ? (
              <p className="text-center">Loading Property...</p>
            ) : projectData.length > 0 ? (
              projectData.map((projectval, index) => (
                <ProjectBox
                  key={index}
                  projectData={projectval}
                  projectcatslug={projectcatslug}
                />
              ))
            ) : (
              <p className="text-center">No Property available right now.</p>
            )}
          </div>

          {/* Pagination */}

          {TotalBlogs > limit && (
            <div className="flex justify-center mt-5 text-center">
              <button
                onClick={() =>
                  setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev))
                }
                disabled={currentPage === 1}
                className="px-3 py-1 mx-1 rounded-lg border bg-white text-gray-700 border-gray-300 hover:bg-gray-100 disabled:opacity-50"
              >
                ⬅ Prev
              </button>

              {renderPagination()}

              <button
                onClick={() =>
                  setCurrentPage((prev) =>
                    prev < totalPages ? prev + 1 : prev
                  )
                }
                disabled={currentPage === totalPages}
                className="px-3 py-1 mx-1 rounded-lg border bg-white text-gray-700 border-gray-300 hover:bg-gray-100 disabled:opacity-50"
              >
                Next ➡
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
